import { supabase } from '@/integrations/supabase/client';

/**
 * Paginate PostgREST reads — default max is 1000 rows, which truncates
 * Progress charts / Exercise list for active users.
 */
export async function fetchAllExerciseRowsForUser<T = any>(
  userId: string,
  options?: {
    exerciseName?: string;
    sinceIso?: string;
    select?: string;
    pageSize?: number;
  },
): Promise<T[]> {
  const pageSize = options?.pageSize ?? 1000;
  const select =
    options?.select ??
    `
      name,
      sets,
      reps,
      weight_kg,
      distance_km,
      duration_seconds,
      set_details,
      notes,
      workouts!inner(
        id,
        title,
        completed_at,
        created_at,
        workout_type,
        user_id,
        duration_minutes,
        calories_burned,
        notes
      )
    `;

  const rows: T[] = [];
  let from = 0;
  for (;;) {
    let query = supabase
      .from('exercises')
      .select(select)
      .eq('workouts.user_id', userId)
      .not('workouts.completed_at', 'is', null)
      .range(from, from + pageSize - 1);

    if (options?.exerciseName) {
      query = query.eq('name', options.exerciseName);
    }
    if (options?.sinceIso) {
      query = query.gte('workouts.completed_at', options.sinceIso);
    }

    const { data, error } = await query;
    if (error) throw error;
    const batch = (data || []) as T[];
    rows.push(...batch);
    if (batch.length < pageSize) break;
    from += pageSize;
    if (from > 50_000) break; // safety
  }
  return rows;
}

export function parseCardioNotes(notes: string | null | undefined): {
  avgBpm?: number | null;
  pace?: string;
  distance?: number;
  durationSeconds?: number;
} {
  if (!notes) return {};
  try {
    const parsed = JSON.parse(notes);
    const hr = parsed?.heartRate;
    return {
      avgBpm: hr?.avgBpm ?? parsed?.avgBpm ?? null,
      pace: typeof parsed?.pace === 'string' ? parsed.pace : undefined,
      distance: parsed?.distance != null ? Number(parsed.distance) : undefined,
      durationSeconds:
        parsed?.durationSeconds != null ? Number(parsed.durationSeconds) : undefined,
    };
  } catch {
    return {};
  }
}
